export default "__VITE_ASSET__CGoIN4AA__"